import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-rating-heart-1",
  "use": "foquz-icon-rating-heart-1-usage",
  "viewBox": "0 0 11 10",
  "content": "<symbol viewBox=\"0 0 11 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-rating-heart-1\"><path d=\"M4.95.856L3.833 3.833 5.762 6.5 4.67 8.764.848 4.942A2.895 2.895 0 014.942.848l.008.008z\" fill=\"#fff\" /><path d=\"M6.004.902l-1.1 2.931L6.835 6.5 5.392 9.487l.107.107 4.652-4.652A2.896 2.896 0 106.058.848l-.054.054z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol